import { useEffect, useState } from "react";

const DEFAULT_TIMEOUT_MS = 15000;

/**
 * True when Keycloak initialization has not finished within `timeoutMs`.
 * Prevents an endless loader when the Keycloak server is unreachable.
 */
export default function useInitTimeout(initialized, timeoutMs = DEFAULT_TIMEOUT_MS) {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (initialized) {
      setTimedOut(false);
      return undefined;
    }

    setTimedOut(false);
    const timer = setTimeout(() => setTimedOut(true), timeoutMs);
    return () => clearTimeout(timer);
  }, [initialized, timeoutMs]);

  return timedOut;
}
